@import '../../vars.css';

.clearIcon {
    color: var(--color-light-neutral-translucent-500);

    &:hover {
        color: var(--color-light-neutral-translucent-500-hover);
    }

    &:active {
        color: var(--color-light-neutral-translucent-500-press);
    }
}
